var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_vm._v("\n    Document closed\n    "),_c('v-dialog',{attrs:{"max-width":"750px"},model:{value:(_vm.isExpanded),callback:function ($$v) {_vm.isExpanded=$$v},expression:"isExpanded"}},[_vm._v("\n        Document Opened\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }